var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 345,
    viewBox: "0 0 379 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 305.251H71.9435V288.72H16.7315V118.99H0V305.251Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306.351 34V50.5319H361.563V220.251H378.294V34H306.351Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.762 282.524C137.486 282.524 94.9638 240.499 94.9638 188.857C94.9638 137.205 137.486 95.1896 189.762 95.1896C242.038 95.1896 284.561 137.205 284.561 188.857C284.561 240.499 242.038 282.524 189.762 282.524ZM189.762 76.4522C127.039 76.4522 76 126.882 76 188.857C76 250.821 127.039 301.251 189.762 301.251C252.485 301.251 303.525 250.821 303.525 188.857C303.525 126.882 252.485 76.4522 189.762 76.4522Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.742 34.2378H176.573C170.188 34.2378 165 40.9539 165 49.2496C165 57.5354 170.188 64.2515 176.573 64.2515H203.742C210.137 64.2515 215.325 57.5354 215.325 49.2496C215.325 40.9539 210.137 34.2378 203.742 34.2378Z",
    fill: "#DF772C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 105.251H16.7315V50.7083H71.9435V34.1765H0V105.251Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M361.563 285.997V286.266H306.351V302.797H378.294V231.712H361.563V285.997Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlack);
export default __webpack_public_path__ + "static/media/icon_black.8ee31c146a6a6a4cf16f2626c42dedb7.svg";
export { ForwardRef as ReactComponent };